function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { constructFrom } from "../constructFrom.js";
export function normalizeDates(context) {
  for (var _len = arguments.length, dates = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    dates[_key - 1] = arguments[_key];
  }
  var normalize = constructFrom.bind(null, context || dates.find(function (date) {
    return _typeof(date) === "object";
  }));
  return dates.map(normalize);
}